import { Box, Actions, Button } from 'braid-design-system';
import React from 'react';

import type { ButtonGroupProps } from './types';

const ButtonGroup = ({
  cancelText,
  successText,
  onSuccess,
  onCancel,
  loading = false,
}: ButtonGroupProps) => (
  <Box background="surface">
    <Actions>
      <Button
        loading={loading}
        onClick={onSuccess}
        tone="formAccent"
        data={{ testid: 'successButton' }}
      >
        {successText}
      </Button>
      <Button variant="transparent" onClick={onCancel}>
        {cancelText}
      </Button>
    </Actions>
  </Box>
);

export default ButtonGroup;
